module.exports = function(app) {
    app.directive('spendingClaimDrawer',
        function() {

            return {
                restrict: 'A',
                replace: true,
                templateUrl: 'spending.appTemplate.html/chmhom/directives/spendingClaimDrawer',

                scope: {
                    claim: '=spendingClaimDrawer'
                },


                controller: ['sessionData', '$scope', '$state', 'services',  'modal', 'storage', '$timeout',  '$q', 'coremetrics', 'session', 'brand','$location','spaUtil','$window',
                    function(sessionData, $scope, $state, services, modal, storage, $timeout,  $q, coremetrics, session, brand,$location,spaUtil,$window) {

                    var spendingClaimIsClicked;
                    $scope.$on('drawerOpen', function() {
                        if(!spendingClaimIsClicked){
                            coremetrics.elementTag('DEBIT CLAIM EXPAND: SPENDING','MEMBER:SPENDING');
                            spendingClaimIsClicked = true;
                        }
                    });

                }]
            };
        }
    );
};